import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

const PRESETS = {
  title: {
    maxWidth: 130,
  },
};

export const StyledCardTitle = styled.div`
  ${({ theme }) =>
    `
      display: none;
      width: 100%;
      padding: ${utils.rem(theme.Spacing.Size.XSmall)} 0;
      align-items: center;
      gap: ${utils.rem(theme.Spacing.Size.XSmall)};

      & > span {
        width: ${utils.rem(PRESETS.title.maxWidth)};
      }

      @media (min-width: ${theme.Screen.Size.Small}px) {
        display: flex;
      };
    `}
`;
export const StyledCardTitleLikeContainer = styled.div`
  ${({ theme }) =>
    `
      display: flex;
      align-items: center;
      margin: 0 0 0 auto;
      gap:${utils.rem(theme.Border.Size.Large)};
      & span {
          color: ${theme.Color.Neutrals.Gray};
      };
      & i {
          fill: ${theme.Color.Neutrals.Gray};
      };
    `}
`;
